import full_page from './full_page'
import checkbox_page from './checkbox_page'
import flip_card_page from './flip_card_page'
import overflow_page from './overflow_page'
import share_page from './share_page'
import selector_page from './selector_page'
import sponsor_page from './sponsor_page'
import post_survey from './post_survey'
import pre_survey from './pre_survey'

export default {
  'full-page': full_page,
  'checkbox-page': checkbox_page,
  'flip-card-page': flip_card_page,
  'overflow-page': overflow_page,
  'share-page': share_page,
  'selector-page': selector_page,
  'sponsor-page': sponsor_page,
  'post-survey': post_survey,
  'pre-survey': pre_survey
}


// WEBPACK FOOTER //
// ./src/templates/pages/index.js